import type { SeverityLevel } from "@sentry/react";
import { addSentryBreadcrumb, isSentryConfigured, isSentryReportingEnabled } from "./sentry";

const SENSITIVE = /password|token|authorization|secret|bearer/i;
const MAX_LEN = 500;

function sanitize(value: unknown): string {
  const text = typeof value === "string" ? value : JSON.stringify(value);
  if (SENSITIVE.test(text)) return "[redacted]";
  return text.length > MAX_LEN ? `${text.slice(0, MAX_LEN)}…` : text;
}

function breadcrumbLevel(level: "log" | "warn" | "error"): SeverityLevel {
  if (level === "log") return "info";
  if (level === "warn") return "warning";
  return "error";
}

export function installOpsConsoleLogger() {
  if (!isSentryConfigured()) return;

  (["log", "warn", "error"] as const).forEach((level) => {
    const original = console[level].bind(console);
    console[level] = (...args: unknown[]) => {
      original(...args);
      if (!isSentryReportingEnabled()) return;
      addSentryBreadcrumb({
        category: "console",
        level: breadcrumbLevel(level),
        message: args.map(sanitize).join(" "),
      });
    };
  });
}
